const getDomainName = () => {
    let hostName = window.location.hostname;
    return hostName.substring(hostName.lastIndexOf('.', hostName.lastIndexOf('.') - 1));
};

const shuffle = (o) => {
    for (
        let j, x, i = o.length;
        i;
        j = parseInt(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x
    );
    return o;
};

const randAdvCookie = (domainName) => {
    if (document.cookie.indexOf('CBS_ADV_VAL') != -1) {
    } else {
        let myArray = new Array('a', 'b', 'c', 'd');
        shuffle(myArray);
        let randAdvChar = myArray[0];
        document.cookie = 'CBS_ADV_VAL=' + randAdvChar + ';domain=' + domainName + ';path=/';
    }
};

const randAdvSubsesCookie = (domainName) => {
    if (document.cookie.indexOf('CBS_ADV_SUBSES_VAL') != -1) {
    } else {
        let myArray = new Array('1', '2', '3', '4');
        shuffle(myArray);
        let randAdvChar = myArray[0];
        document.cookie = 'CBS_ADV_SUBSES_VAL=' + randAdvChar + ';domain=' + domainName + ';path=/';
    }
};

let domainName = getDomainName();
randAdvCookie(domainName);
randAdvSubsesCookie(domainName);
